import React from "react";
import { CpCheckbox } from "@components";
import type { CpCheckboxProps } from "../cp-checkbox";
import {
  useController,
  Control,
  RegisterOptions,
  UseControllerProps,
  FieldValues,
  FieldPath,
} from "react-hook-form";

type CpCheckboxFieldProps<TFieldValues extends FieldValues = FieldValues> =
  Omit<CpCheckboxProps, "checked" | "onChange" | "onBlur"> & {
    fieldName: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    controllerOptions?: Omit<
      UseControllerProps<TFieldValues>,
      "name" | "control" | "rules"
    >;
    rules?: RegisterOptions<TFieldValues>;
  };

export function CpCheckboxField<TFieldValues extends FieldValues = FieldValues>(
  props: CpCheckboxFieldProps<TFieldValues>,
) {
  const { fieldName, control, controllerOptions, rules, ...cpCheckboxProps } =
    props;
  const {
    field: { value, onBlur, onChange },
  } = useController({ name: fieldName, control, rules, ...controllerOptions });

  return (
    <CpCheckbox
      {...cpCheckboxProps}
      checked={value}
      onBlur={onBlur}
      onChange={onChange}
    />
  );
}
